import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const FiberManualRecord = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <circle cx="12" cy="12" r="8" />
  </IconSvg>
);

export default FiberManualRecord;
